import { Part } from "./Part";

export const INITIAL_VALUES: Part = {
	partId: 0,
	partName: "",
	description: "",
	sku: "",
	unit: "",
	partStateId: 0,
	vendorId: 0,
	refurbishVendor: new Date(),
	removalDate: new Date(),
	sendToVendorDate: new Date(),
	estimatedArrival: new Date(),
	actualArrival: new Date(),
	isActive: true,
};
